<template>
  <div id="app">
    <div id="nav">
      <Header/>
    </div>
    <div class="body-scroll" v-show="showLogin" style="text-align: center;">
      <Login></Login>
<!--      <div style="margin-top: -4%">
        <b-button variant="link" @click="showSystemRequirements = !showSystemRequirements, showLogin = !showLogin">
          {{$t('msg.system_requirements')}}
        </b-button>
        <br>
        <b-button variant="link" @click="showTroubleshooting = !showTroubleshooting, showLogin = !showLogin">
          {{$t('msg.troubleshooting')}}
        </b-button>
      </div>-->
    </div>
    <div>
      <system-requirements v-show="showSystemRequirements"></system-requirements>
    </div>
    <div>
      <troubleshooting v-show="showTroubleshooting"></troubleshooting>
    </div>
    <div class="add-area"></div>
    <Footer class="footer"></Footer>
  </div>
</template>

<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
import Login from '../components/Login'
import SystemRequirements from '@/components/SystemRequirements'
import Troubleshooting from '@/components/Troubleshooting'

export default {
  components: {
    Troubleshooting,
    SystemRequirements,
    Header,
    Footer,
    Login
  },
  data () {
    return {
      showLogin: true,
      showSystemRequirements: false,
      showTroubleshooting: false
    }
  }
}
</script>

<style>
#app {
  font-family: 'Ubuntu', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
  font-size: 16px;
}

#nav {
  padding: 0px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.margin-top {
  margin-top: 100px;
}

.footer {
  bottom: 0;
  position: fixed;
  width: 100%;
}

.add-area {
  padding-bottom: 7%;
}

#id {
  height: 100%;
}

.body-scroll {
  position: absolute;
  top: 90px;
  bottom: 50px;
  left: 0px;
  right: 0px;
  overflow: auto;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}
</style>
